import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const limit = 2000;
export const findDocuments = createAsyncThunk(
  "locationShow/findDocuments",
  async (idLocation: string, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    try {
      const where = {
        locations: { contains: `${idLocation}]` },
        source: "migs",
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      };
      const page = 1;

      const listPromise = axiosInstance.get(`${api.baseURL}document`, {
        params: {
          where,
          sort: "createdAt DESC",
          page,
          limit,
        },
      });
      const countPromise = axiosInstance.post(`${api.baseURL}document/count`, {
        where,
      });

      if (page === 1) {
        const [{ data: list }, { data: count }] = await Promise.all([listPromise, countPromise]);

        return [list, count];
      } else {
        const { data: list } = await listPromise;

        return [list];
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
